module.exports = __webpack_public_path__ + "static/img/banner_about.2f3e746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_about.png
// module id = OJ/O
// module chunks = 15